<template lang="pug">
  b-container(fluid="fluid")
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-form-text.ml-3.mt-3.error-message-color(v-if="error_msg !== ''") {{error_msg}}
      //- 各変更申込ボタンについて、表示条件の追加が必要であり、開発工数が増えるため非表示にしておく
      //- b-button.ml-3.mt-3.mb-4(v-if="is_user_display === 1 && this.sales_channel !== '1'" variant="primary", :to="{name: 'NeoNumberChange'}" data-testid="btn_service_change") ユーザー数変更お申込み
      //- b-button.ml-3.mt-3.mb-4(variant="primary", :to="{name: changePath}" data-testid="btn_service_change") ご契約内容変更お申込み
      b-row
        b-col.ml-3.mr-3
          h3.font-weight-bold.mb-2 申し込み履歴
          div
            b-table-simple.rounded.table-font-size(small, responsive=false, borderless=true)
              b-thead(head-variant="light")
                b-tr.border-bottom
                  b-th(v-for="(field, key) in fields", :key="key", :class="field.class") {{field.label}}
              b-tbody
                //- お申込み履歴単位
                template(v-for="(order_history_row, key) in order_history")
                  //- 注文情報単位
                  template(v-for="(order_row, order_key) in order_history_row.orders")
                    //- 行は注文明細単位
                    b-tr(v-for="(detail_row, detail_key) in order_row.change_details", :key="`${key}-${detail_key}`", :class="(order_history_row['job_sts'] === '3' ? 'cancel_color' : '') + ' ' + ((order_history_row.orders.length - 1) === Number(order_key) && (Object.keys(order_row.change_details).map(Number).pop()) === Number(detail_key) ? 'order-border-bottom' : '')")
                      //- 注文情報・注文明細の1行目のみ ステータス・見積書・申込日時・開通希望日・商品カテゴリー を表示
                      template(v-if="order_key === 0 && isFirstRow(detail_key, order_row)")
                        b-td.row-height.status-max-width.px-0(:class="order_history_row.job_sts === '3' ? 'canceled-label-after' : order_history_row.job_sts === '1' ? 'active-label-after' : ''")
                        b-td.row-height.quotation-width.text-center
                          template(v-if="order_history_row.estimate_branch !== null")
                            b-icon.link(title="ダウンロード", icon="file-pdf" font-scale="2", variant="danger", @click="downloadQuotationPDF(order_history_row.estimate_branch)", :style="{ pointerEvents: isDisabled ? 'none' : 'auto' }")
                        b-td.row-height.regist-date-width {{order_history_row.regist_date}}
                        b-td.row-height.opening-date-width {{order_history_row.opening_date}}
                        b-td.row-height.item-categories-width
                          template(v-for="(item_category, cate_key) in order_history_row.itemCategories")
                            b-badge(:key="cate_key", pill, :class="item_category === 'NEO' ? 'bg-primary' : 'chat-bg-color'") {{item_category}}
                            br(v-if="(cate_key + 1) !== detail_row.item_categories.length")
                      //- 注文明細の2行目以降は空にする
                      template(v-else)
                        b-td.row-height
                        b-td.row-height.quotation-width
                        b-td.row-height.regist-date-width
                        b-td.row-height.opening-date-width
                        b-td.row-height.item-categories-width
                      //- 注文明細
                      b-td.row-height.table-pre-wrap.item-code-width(:class="detailBorderCheck(order_row.change_details.length, detail_key)") {{item_name_list[detail_row.item_code]}}
                      b-td.row-height.item-before-width(:class="detailBorderCheck(order_row.change_details.length, detail_key)") {{detail_row.before_data}}
                      b-td.row-height.item-after-width(:class="detailBorderCheck(order_row.change_details.length, detail_key)") {{detail_row.after_data}}
                      //- 注文明細の1行目のみメモを表示
                      template(v-if="isFirstRow(detail_key, order_row)")
                        b-td.row-height.order-note-width(:class="detailBorderCheck(order_row.change_details.length, detail_key)", :rowspan="Object.keys(order_row.change_details).length")
                          b-row.nowrap.mr-0(col="2")
                            b-col(cols="1")
                              b-icon.mr-2.link(title="編集", icon="pencil-square", font-scale="1.2", @click="openModalEditOrderNote(order_row)")
                            b-col.pr-2(cols="11")
                              template(v-if="order_row.order_note")
                                template(v-if="order_row.isClosed")
                                  p.over-text.order-note-wrap(:style="'max-height: ' + (40 * Object.keys(order_row.change_details).length) + 'px; -webkit-line-clamp: ' + Object.keys(order_row.change_details).length * 2 +';'") {{order_row.order_note}}
                                  b-link(@click="openOrderNote(order_row)") 全文表示
                                template(v-else)
                                  p.order-note-wrap {{order_row.order_note}}
                                  b-link(@click="closeOrderNote(order_row)") 閉じる
                              template(v-else)
                                b-link(@click="openModalEditOrderNote(order_row)") メモを登録する
      modal-edit-order-note(:order_info="order_info", @getOrderHistory="getOrderHistory")
</template>

<script>
import Api from "@/repositories/api"
import Loading from "@/components/Loading"
import ModalEditOrderNote from '@/components/supportSite/ModalEditOrderNote.vue';

const C206ContractInfo = Api.get('c206ContractInfo');
const S210OrderHistoryRepository = Api.get("s210OrderHistory");
const S214QuotationRepository = Api.get("s214Quotation");

export default {
  name: "OrderHistoryData",
  components: {
    Loading,
    ModalEditOrderNote
  },
  props: {
    sales_channel: {type: String, required: false}
  },
  data() {
    return {
      fields: {
        job_sts: { label: "", sortable: false, class: "status-max-width px-0" },
        quotation_no: { label: '見積書', sortable: false, class: 'quotation-width' },
        regist_date: { label: "申込日時", sortable: false, class: "regist-date-width" },
        opening_date: { label: "開通希望日", sortable: false, class: "opening-date-width" },
        item_categories: { label: "", sortable: false, class: "item-categories-width" },
        item_code: { label: "商品名", sortable: false, class: "item-code-width" },
        item_before: { label: "変更前", sortable: false, class: "item-before-width" },
        item_after: { label: "変更後", sortable: false, class: "item-after-width" },
        order_note: { label: "メモ", sortable: false, class: "order-note-width" },
      },

      // ユーザー数変更お申込みボタンの表示フラグ
      // is_user_display: 0,

      // お申込み履歴
      order_history: [],

      // ローディングフラグ
      isLoading: false,

      // 商品リスト
      item_name_list: this.getItemList(),

      // エラーメッセージ
      error_msg: "",

      // 注文情報
      order_info: {
        accept_no: "",
        order_note: ""
      },

      // ボタン無効フラグ
      isDisabled: false,
    }
  },
  created() {
    // ユーザー数変更お申込みボタンの表示設定
    // if (this.contract_class === "5") {
    //   this.is_user_display = 1;
    // }
    // else {
    //   this.is_user_display = 0;
    // }

    // 読み込み中
    this.isLoading = true;

    // 画面パラメータに契約番号が存在する場合
    if ('contract_no' in this.$route.params) {
      // S21001_お申し込み履歴表示を実行
      this.getOrderHistory({contract_no: this.$route.params.contract_no})
    }
    // 画面パラメータに契約番号が存在しない場合
    else {
      // C20601_契約情報取得処理を実行
      C206ContractInfo.get({})
        .then((response) => {
          // 取得した契約情報数が1件の場合
          if (response.data.data.length === 1) {
            // S21001_お申し込み履歴表示を実行
            this.getOrderHistory({contract_no: response.data.data[0].contract_no})
          }
          else {
            // セッションストレージにデータを保存
            sessionStorage.setItem('previous', 'OrderHistory')
            // セッションストレージから契約種別を削除
            sessionStorage.removeItem('contract_class')

            // S11500_ご契約環境選択画面に遷移
            this.$router.push({ name: 'ContractSelect' })
          }
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, "画面表示処理")

          // バリデーションエラー
          if (error.response.data.error_list) {
            // エラーメッセージをセット
            this.error_msg = error.response.data.error_list[0].error_msg;
          }
        })
    }
  },
  computed: {
    // ご契約内容変更画面の遷移先を設定
    // changePath () {
    //   // 契約種別が"5"の場合
    //   if (this.contract_class === "5") {
    //     return "NeoServiceChange";
    //   }
    //   else {
    //     return "ChatServiceChange";
    //   }
    // }
  },
  methods: {
    detailBorderCheck(length, index) {
      return length - 1 !== index ? "detail-border-bottom" : "";
    },
    getOrderHistory(params) {
      // ローディング開始
      this.isLoading = true;
      // お申込み履歴を初期化する
      this.order_history = []

      // APIからデータ取得する
      S210OrderHistoryRepository.get(params)
        .then((response) => {
          // お申込み履歴を取得する
          const orderHistory = response.data.data

          // お申込み履歴を整形する
          for (let orderHistoryData of orderHistory) {
            // 初期化：商品カテゴリー
            orderHistoryData.itemCategories = []

            // 注文情報を整形する
            for (let order of orderHistoryData.orders) {
              // メモの開閉の初期値を設定
              order.isClosed = true
              // 注文明細情報を取得
              const changeDetails = order.change_details

              // 注文明細を整形する
              for (let key in changeDetails) {
                // 商品カテゴリーをお申込み履歴単位にまとめる
                orderHistoryData.itemCategories = orderHistoryData.itemCategories.concat(changeDetails[key].item_categories)

                // 数量の後ろにつける単位名
                let unit_name = ''
                // 商品コードを見て変更前、変更後データの後ろにつける単位を設定
                switch (changeDetails[key].item_code) {
                  // desknet's NEO ウェブ会議
                  case 'KWEBJST1MB001':
                    unit_name = '会議室'
                    break;
                  // RoomMgr
                  case 'KRMGJAC1MB000':
                    changeDetails[key].before_data = 'ご利用中'
                    changeDetails[key].after_data = '追加'
                    break;
                  // ディスク増設
                  case 'KNEDJAC1MS000': // NEOディスク増設（価格改定後）
                  case 'KHDDJAC1MS000': // NEOディスク増設（価格改定前）
                  case 'KCHTJAC1MS001': // ChatLuckディスク増設
                    // 20 * 数量
                    changeDetails[key].before_data *= 20
                    changeDetails[key].after_data *= 20
                    unit_name = 'GB増設'
                    break;
                  // desknet'sドライブ ディスク増設
                  case 'KDRDJAC1MS000': // desknet'sドライブ ディスク増設
                    // 20 * 数量
                    changeDetails[key].before_data *= 20
                    changeDetails[key].after_data *= 20
                    unit_name = 'GB増設'
                    break;
                  // BASIC認証
                  // 接続元IPアドレス制限
                  // クライアント認証 IP設定
                  // セキュアブラウザ IP設定
                  case 'KBATJAC1MS000':
                  case 'KCTBJAC1MS000':
                  case 'KRIPJAC1MS000':
                  case 'KCTIJAC1MS000':
                  case 'KIPNJAC1MS000':
                  case 'SECURE_IP':
                    changeDetails[key].before_data = 'ご利用中'
                    changeDetails[key].after_data = changeDetails[key].details_type === '0' ? '追加' : '更新'
                    break;
                  // セキュアブラウザ 証明書再発行
                  case 'SECURE_RE':
                    changeDetails[key].before_data = ''
                    changeDetails[key].after_data = ''
                    break
                  // セキュアブラウザ 端末認証あり
                  case 'KSBDJAC1MS000':
                  case 'KCCNJAC1MS000':
                    unit_name = 'デバイス'
                    break;
                  // WEBARENA
                  // CYBERMAIL
                  case 'KMLSJST1MB001':
                  case 'KMLSJCB1MB005':
                  case 'KMLSJCB1MB010':
                  case 'KMLSJCB1MB050':
                  case 'KMLSJCB1MB100':
                  case 'KMLSJCB1MAPLK':
                  case 'KMLSJCB1MAPEN':
                  case 'KMLSJCB1MAA05':
                  case 'KMLSJCB1MAA07':
                  case 'KMLSJCB1MAA10':
                  case 'KMLSJCB1MASBX':
                  case 'KMLSJMG1MBVSS':
                  case 'KMLSJMG1MBPLK':
                  case 'KMLSJMG1MBPEN':
                    unit_name = 'アカウント'
                    break;
                  // その他
                  default:
                    unit_name = 'ユーザー'
                    break;
                }

                // 変更前のデータに単位を追加
                changeDetails[key].before_data += unit_name
                // 変更後のデータに単位を追加
                changeDetails[key].after_data += unit_name

                // 明細種別が新規の場合
                if (changeDetails[key].details_type === '0') {
                  // 変更前のデータを空文字で上書きする
                  changeDetails[key].before_data = ''
                }
                // 明細種別が解約の場合
                if (changeDetails[key].details_type === '2') {
                  // 変更後のデータを「解約」で上書きする
                  changeDetails[key].after_data = '解約'
                }
              }

              // 商品カテゴリーの重複を省く
              orderHistoryData.itemCategories = Array.from(new Set(orderHistoryData.itemCategories))

              // メモがnullの場合、空文字にセット
              if (order.order_note === null) {
                order.order_note = ''
              }

              // 注文明細の最初の明細番号を取得
              order.firstRowNo = this.getFirstOrLastDetailNo(Object.keys(order.change_details), true)
              // 注文明細の最後の明細番号を取得
              // order.lastRowNo = this.getFirstOrLastDetailNo(Object.keys(order.change_details), false)
            }

            // 整形したお申込み履歴をセットする
            this.order_history.push(orderHistoryData)
          }
        })
        .catch((error) => {
          // 共通のエラー処理
          this.apiError(error, '画面表示処理')

          // バリデーションエラー
          if (error.response.data.error_list) {
            // エラーメッセージをセット
            this.error_msg = error.response.data.error_list[0].error_msg;
          }
        })
        .finally(() => {
          // ローディング終了
          this.isLoading = false
        })
    },
    // メモ編集ダイアログを開く
    openModalEditOrderNote(data) {
      // 現在の注文情報を設定
      this.order_info = {
        accept_no: data.accept_no,
        order_note: data.order_note
      }

      // ダイアログを開く
      this.$bvModal.show('modal-edit-order-note')
    },
    // メモの全文を表示する
    openOrderNote (value) {
      // 開閉フラグを開くにセット
      value.isClosed = false
    },
    // メモの一部（表の高さ分）を表示する
    closeOrderNote (value) {
      // 開閉フラグを閉じるにセット
      value.isClosed = true
    },
    // 注文明細の最初か最後の明細番号取得
    getFirstOrLastDetailNo (change_details, isFirst) {
      // 注文明細番号を昇順で並び替えする
      const sortedKeys = change_details.sort((a, b) => a > b)

      // 最初
      if (isFirst === true) {
        return sortedKeys[0]
      }
      // 最後
      else {
        return sortedKeys[sortedKeys.length - 1]
      }
    },
    // 注文明細の最初の行であるか
    isFirstRow(detail_key, order_row) {
      return detail_key === order_row.firstRowNo
    },
    /**
     * 見積書PDFをダウンロードする
     * @param string estimate_branch 見積枝番
     */
    downloadQuotationPDF (estimate_branch) {
      // ボタンを無効化する
      this.isDisabled = true

      // S21404_見積書取得処理
      S214QuotationRepository.get({estimate_branch: estimate_branch})
        // 処理に成功した場合
        .then((response) => {
          // ファイル名を取得する
          let title = response.headers['content-disposition'].replace('attachment; filename*=UTF-8\'\'', '')
          // PDFをダウンロードする
          this.downloadBlobFile(response.data, title, 'application/pdf')
        })
        // 処理に失敗した場合
        .catch((error) => {
          // エラーレスポンスがある場合
          if (error.response && 'status' in error.response) {
            // 共通のエラー処理を行う
            this.apiError(error, '見積書取得処理', "Support")

            // バリデーションエラーの場合
            if (error.response.data.error_list) {
              for (let errorData of error.response.data.error_list) {
                // エラーメッセージをセットする
                this.errors.push(errorData.error_msg)
              }
            }
          }
          // エラーレスポンスがない場合
          else {
            // エラーメッセージをセットする
            this.setErrors(error)
          }
        })
        .finally(() => {
          // ボタンを有効化する
          this.isDisabled = false
        })
    }
  },
}
</script>

<style scoped lang="scss">
.status-max-width {
  width: 100px !important;
}

.order-border-bottom {
  border-bottom: solid;
  border-bottom-width: 1.5px !important;
  border-color: #c6c9cc !important;
}

.detail-border-bottom {
  border-bottom: solid;
  border-bottom-width: 1px !important;
  border-color: #dadde0 !important;
}

.row-height {
  padding-top: 10px;
  padding-bottom: 10px;
}

.table-pre-wrap {
  white-space: pre-wrap;
}

.canceled-label-after:after {
  content: "キャンセル";
  background-color: gray;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  min-width: 90px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin: 0px 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}

.active-label-after:after {
  content: "作業中";
  background-color: #ffc107;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  min-width: 90px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin: 0px 5px 2px;
  line-height: 1;
  vertical-align: middle;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
  display: inline-block;
}

.cancel_color {
  background-color: #e8e8e8;
}

/* 表の幅を指定 */

.regist-date-width {
  min-width: 8rem;
  max-width: 8rem;
}

.quotation-width {
  min-width: 3rem;
  max-width: 3rem;
}

.opening-date-width {
  min-width: 5rem;
  max-width: 5rem;
}

.item-catigories-width {
  min-width: 3rem;
  max-width: 3rem;

  span {
    font-size: 13px;
  }
}

.item-code-width {
  min-width: 14rem;
  max-width: 14rem;
}

.item-before-width {
  min-width: 6rem;
  max-width: 6rem;
}

.item-after-width {
  min-width: 6rem;
  max-width: 6rem;
}

.order-note-width {
  min-width: 10rem;
  max-width: 10rem;
}

.nowrap {
  flex-wrap: nowrap;
}

.order-note-wrap {
  white-space: break-spaces;
  overflow-wrap: break-word;
}

.over-text {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.link {
  cursor: pointer;
}
</style>
